import * as Dialog from '@radix-ui/react-dialog'
import { Link } from 'react-router'
import { Button } from './ui/button'
import { Icon } from './ui/icon'

type PricingModalProps = {
	open: boolean
	onOpenChange: (open: boolean) => void
}

export function PricingModal({ open, onOpenChange }: PricingModalProps) {
	return (
		<Dialog.Root open={open} onOpenChange={onOpenChange}>
			<Dialog.Portal>
				<Dialog.Overlay className="fixed inset-0 z-50 bg-black/50" />
				<Dialog.Content className="fixed left-1/2 top-1/2 z-50 max-h-[90vh] w-full max-w-4xl -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-xl bg-white p-8 shadow-xl">
					<div className="mb-6 flex items-center justify-between">
						<Dialog.Title className="text-2xl font-bold text-gray-900">
							Pricing Details
						</Dialog.Title>
						<Dialog.Close asChild>
							<button
								type="button"
								className="text-gray-400 hover:text-gray-600"
								aria-label="Close"
							>
								<Icon name="cross-1" className="h-6 w-6" />
							</button>
						</Dialog.Close>
					</div>

					{/* Feature Comparison Table */}
					<div className="overflow-x-auto">
						<table className="w-full">
							<thead>
								<tr className="border-b-2 border-gray-200">
									<th className="px-4 py-4 text-left font-semibold text-gray-900">
										Feature
									</th>
									<th className="px-4 py-4 text-center font-semibold text-gray-600">
										Free
									</th>
									<th className="px-4 py-4 text-center font-bold text-purple-600">
										Practitioner
									</th>
									<th className="px-4 py-4 text-center font-semibold text-gray-600">
										Couple
									</th>
								</tr>
							</thead>
							<tbody className="divide-y divide-gray-100">
								<tr>
									<td className="px-4 py-3 text-gray-700">
										Basic Billings charting
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
								</tr>
								<tr className="bg-gray-50">
									<td className="px-4 py-3 text-gray-700">Local storage</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
								</tr>
								<tr>
									<td className="px-4 py-3 text-gray-700">
										AI pattern recognition
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="cross-1"
											className="mx-auto h-5 w-5 text-gray-300"
										/>
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
								</tr>
								<tr className="bg-gray-50">
									<td className="px-4 py-3 text-gray-700">
										Instructor-ready exports
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="cross-1"
											className="mx-auto h-5 w-5 text-gray-300"
										/>
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
								</tr>
								<tr>
									<td className="px-4 py-3 text-gray-700">Partner access</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="cross-1"
											className="mx-auto h-5 w-5 text-gray-300"
										/>
									</td>
									<td className="px-4 py-3 text-center text-sm text-gray-500">
										Read-only
									</td>
									<td className="px-4 py-3 text-center">
										<Icon
											name="check"
											className="mx-auto h-5 w-5 text-green-600"
										/>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div className="mt-8 flex justify-end gap-4">
						<Dialog.Close asChild>
							<Button variant="outline" size="lg">
								Close
							</Button>
						</Dialog.Close>
						<Button asChild size="lg">
							<Link to="/checkout/PRACTITIONER?beta=true">
								Reserve Beta Access
							</Link>
						</Button>
					</div>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	)
}
